import { render, staticRenderFns } from "./CardSplit.vue?vue&type=template&id=b0d9487e"
import script from "./CardSplit.js?vue&type=script&lang=js&external"
export * from "./CardSplit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports